import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TimeAccuracy } from '../../../entities/time-accuracy.entity';
import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { ShFormTimeBaseComponent } from '../base-simple/form-time-base.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ShFormTimeComplexBaseComponent } from '../base-complex/form-time-complex-base.component';
import { NgIf, NgClass, AsyncPipe } from '@angular/common';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';

@Component({
    selector: 'sh-form-time',
    templateUrl: './form-time.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ShFormGroupComponent, NgIf, ShFormTimeComplexBaseComponent, ReactiveFormsModule, NgClass, ShFormTimeBaseComponent, AsyncPipe]
})
export class ShFormTimeComponent extends ShBaseFormComponent {
    @Input() autocomplete = 'off';
    @Input() placeholder?: string;
    @Input() min?: string;
    @Input() max?: string;
    @Input() timeAccuracy?: TimeAccuracy;
}
